import { useMemo } from 'react';
import { getCrmDbSchema, type DbPortalKind } from '../lib/supabase';
import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

type Options = {
  enabled?: boolean;
  portalKind?: DbPortalKind;
  /** When set, only events for this owner_id schedule a reload. */
  ownerId?: string | null;
  onChange?: () => void;
};

/**
 * Live-refresh monthly visitation list when rows change (other tabs / users / task sync).
 */
export function useMonthlyVisitationRealtime(options: Options = {}) {
  const { enabled = true, portalKind = 'crm', ownerId, onChange } = options;
  const schema = getCrmDbSchema(portalKind);
  const filter = ownerId ? `owner_id=eq.${ownerId}` : undefined;
  const listens = useMemo(
    () => [{ schema, table: 'monthly_visitation_items', filter }],
    [schema, filter],
  );

  usePostgresChangesRealtime({
    enabled: enabled && (portalKind === 'crm' || portalKind === 'it'),
    channelName: `visitation-live:${portalKind}:${ownerId ?? 'all'}`,
    portalKind,
    debounceMs: 400,
    onChange,
    listens,
  });
}
